import { createContext, useContext } from 'react';

export type RouteNoticeTone = 'warning' | 'success';

export interface RouteNoticeInput {
  message: string;
  tone: RouteNoticeTone;
  destination: string;
  originKey: string;
}

export interface RouteNoticeContextValue {
  announce: (notice: RouteNoticeInput) => void;
}

export const RouteNoticeContext = createContext<RouteNoticeContextValue | null>(null);

export function useRouteNotice(): RouteNoticeContextValue {
  const context = useContext(RouteNoticeContext);
  if (!context) {
    throw new Error('useRouteNotice must be used within RouteNoticeProvider');
  }
  return context;
}
